var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 144.309,
    height: 143.824,
    rx: 23,
    transform: "matrix(0.940174 0.340694 -0.34335 0.939207 54.3125 0)",
    fill: "#FF2F48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14514_17602)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 45.8711,
    width: 144.129,
    height: 144.129,
    rx: 23,
    fill: "url(#paint0_radial_14514_17602)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14514_17602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4952 105.832C53.4952 109.36 56.3032 112.168 59.8312 112.168C63.3592 112.168 66.1672 109.36 66.1672 105.832C66.1672 102.304 63.3592 99.496 59.8312 99.496C56.3032 99.496 53.4952 102.304 53.4952 105.832ZM53.4952 129.664C53.4952 133.192 56.3032 136 59.8312 136C63.3592 136 66.1672 133.192 66.1672 129.664C66.1672 126.136 63.3592 123.328 59.8312 123.328C56.3032 123.328 53.4952 126.136 53.4952 129.664ZM95.9127 150.112C87.7767 140.176 84.1047 127 84.1047 117.64C84.1047 107.92 87.8487 94.096 95.1927 85.096H84.3207C77.1207 93.736 73.0167 104.392 73.0167 117.352C73.0167 130.024 77.0487 140.536 84.7527 150.112H95.9127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14514_17602",
    x: -3,
    y: 42.8711,
    width: 150.129,
    height: 150.129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14514_17602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14514_17602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14514_17602",
    x: 53.4961,
    y: 85.0962,
    width: 51.836,
    height: 74.4336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14514_17602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14514_17602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14514_17602",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0644 117.935) rotate(90) scale(79.2708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA6BA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA6BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIcon);
export default __webpack_public_path__ + "static/media/sad-icon.7a827075307781bee8884c79697932df.svg";
export { ForwardRef as ReactComponent };